import { z } from 'zod';
import { DEFAULT_VAT_RATES, PRODUCT_UNITS } from '../constants/index.js';
import { positiveDecimalStringSchema, uuidSchema } from './common.js';
export const productCategorySchema = z.object({
    id: uuidSchema,
    name: z.string(),
    sortOrder: z.number().int(),
    isActive: z.boolean(),
});
export const createProductCategorySchema = z.object({
    name: z.string().trim().min(1).max(120),
    sortOrder: z.coerce.number().int().min(0).default(0),
    isActive: z.boolean().default(true),
});
export const updateProductCategorySchema = createProductCategorySchema.partial();
/**
 * IVA rate. The allowed set is configurable in settings; this only enforces that
 * it is a sane whole percentage, with the configured list checked server-side.
 */
export const vatRateSchema = z.coerce
    .number()
    .int()
    .min(0)
    .max(100)
    .describe(`Typically one of ${DEFAULT_VAT_RATES.join(', ')}`);
export const createProductSchema = z.object({
    sku: z
        .string()
        .trim()
        .min(1)
        .max(40)
        .regex(/^[A-Za-z0-9._/-]+$/, { message: 'validation.sku' }),
    name: z.string().trim().min(1).max(200),
    categoryId: uuidSchema.nullish(),
    unit: z.enum(PRODUCT_UNITS).default('piece'),
    unitsPerCase: z.coerce.number().int().min(1).default(1),
    /** Net price, VAT excluded. A string so no precision is lost in transit. */
    price: positiveDecimalStringSchema,
    vatRate: vatRateSchema,
    notes: z.string().trim().max(2000).nullish(),
    isActive: z.boolean().default(true),
});
export const updateProductSchema = createProductSchema.partial();
export const productSchema = z.object({
    id: uuidSchema,
    sku: z.string(),
    name: z.string(),
    categoryId: uuidSchema.nullable(),
    categoryName: z.string().nullable(),
    unit: z.enum(PRODUCT_UNITS),
    unitsPerCase: z.number().int(),
    price: z.string(),
    vatRate: z.number().int(),
    imagePath: z.string().nullable(),
    notes: z.string().nullable(),
    isActive: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const productListQueryExtras = z.object({
    categoryId: uuidSchema.optional(),
    isActive: z.enum(['true', 'false']).optional(),
});
//# sourceMappingURL=product.js.map